import React from 'react';
import Header from '../header.js';
import HeroSection from '../hero-section.js';
import AboutUs from '../aboutUs.js'
import Achievements from '../achievements.js'
import Projects from '../projects.js';
import QuoteSection from '../quoteSection.js';
import HowToHelpSection from '../howToHelp.js';
import Partners from '../partners.js';
import IdeaSection from '../ideaSection.js'
import Footer from '../footer.js';

const MainPage = ({fadeIn}) => {
    
    return (
        <div className={`main-content ${fadeIn ? 'fade-in' : ''}`}>
            <div>
                <Header />
                </div>
            <HeroSection />
            <AboutUs />
            <Achievements />
            <Projects />
            <QuoteSection />
            <HowToHelpSection />
            <Partners />
            <IdeaSection />
            <Footer />
        </div>
    );
};

export default MainPage;